import { render, staticRenderFns } from "./CategoriaRepresentivaShow.vue?vue&type=template&id=563d4e1a&scoped=true&"
import script from "./CategoriaRepresentivaShow.vue?vue&type=script&lang=js&"
export * from "./CategoriaRepresentivaShow.vue?vue&type=script&lang=js&"
import style0 from "./CategoriaRepresentivaShow.vue?vue&type=style&index=0&id=563d4e1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563d4e1a",
  null
  
)

export default component.exports